// @ts-nocheck
import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useActions } from '../hooks/useActions';
import { useTypedSelector } from '../hooks/useTypedSelector';
import { SuperPhaseTypeIds } from '../const/SuperPhaseTypes';
import { IAddEntityModalParameters } from '../models/AddEntityModalParameters';
import { IBoard } from './kanbanBoard/models/BoardModel';
import { ModalTypes } from '../const/ModalTypes';

const ICON_BUTTON_SX = { minWidth: 38.5, width: 38.5, height: 38.5, p: 1 } as const;

interface AddCardButtonProps {
  board: IBoard<any>;
  disabled?: boolean;
}

const AddCardButton: React.FC<AddCardButtonProps> = ({ board, disabled = false }) => {
  const { openProjectsModal } = useActions();
  const { boardId, lanes } = board ?? {};
  const { id = 0, title = 'null' } = lanes?.[0] ?? {};

  const currentProjectReleaseId =
    useTypedSelector((s) => s.project.currentProjectReleaseId) ?? null;

  const project = useTypedSelector((s) => s.project.project);

  const TodoPhase = project?.projectPhases?.find(
    (p: any) => Number(p.superPhaseId) === SuperPhaseTypeIds.TODO
  );

  const modalParameters: IAddEntityModalParameters = {
    headerPlaceholder: `Add card`,
    textPlaceholder: 'Enter a title for a new card...',
    addEntityButtonPlaceholder: 'Add card',
    cancelEntityButtonPlaceholder: 'Cancel',
    addEntitiesButtonPlaceholder: 'Add # cards',

    taskPhaseId: TodoPhase?.id,
    projectId: boardId,
    projectReleaseId: currentProjectReleaseId,
  } as IAddEntityModalParameters;

  const openModal = () => {
    openProjectsModal(modalParameters, null, null, ModalTypes.CreateTaskModal);
  };

  return (
    <Tooltip title="Add card" arrow>
      <span>
        <Button
          variant="outlined"
          color="primary"
          onClick={openModal}
          disabled={disabled}
          size="medium"
          sx={ICON_BUTTON_SX}
        >
          <AddIcon />
        </Button>
      </span>
    </Tooltip>
  );
};

export default AddCardButton;
